<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'nodeTypesCrud'"
          :crudName="$t('nodeType.title')"
          :newText="$t('nodeType.form.newText')"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="$hasAbility('node.admin')"
          :enableEdit="$hasAbility('node.admin')"
          :enableDelete="$hasAbility('node.admin')"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data() {
    return {
      table: "nodeTypesTable",
      columns: ["id", "name", "actions"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name"],
        sortable: ["id", "name"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          name: this.$t("nodeType.table.name"),
          actions: this.$t("common.actions"),
        },
        texts: {
          filterBy: this.$t("nodeType.table.filterBy"),
          defaultOption: this.$t("common.select"),
        },
        requestFunction(data) {
          let requestData = { params: data };
          requestData.params.query = "";
          return axios
            .get(this.url, requestData)
            .catch((e) => this.dispatch("error", e));
        },
      },
      endPoint: "node_types",
      dataForm: {},
    };
  },
  components: { BaseCrud },
  methods: {
    query(query) {
      let columns = { id: "id", name: "name" };
      let filters = "";
      $.each(query, (index, value) => {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>
